export default "__VITE_ASSET__lvCfZs15__"